export default __webpack_public_path__ + "static/media/videoIcon.97cb96d8.svg";